export default {"src":"/_next/static/media/pocket.2c3f46ea.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};